import api from "./api";
import { buildDireccionPropiedad } from "../utils/buildDireccionPropiedad";

/**
 * Geocodifica la dirección de una propiedad vía backend (Google Geocoding API).
 * @param {object} form
 * @param {{ tipoViaNombre?: string, poblacionNombre?: string, provinciaNombre?: string }} ctx
 */
export async function geocodeDireccionPropiedad(form, ctx = {}) {
  const address = buildDireccionPropiedad(form, ctx);
  if (!address || address.replace(/España/gi, "").trim().length < 8) {
    return { ok: false, error: "address_too_short" };
  }
  const { data } = await api.post("/geo/geocode-direccion", { address });
  return data || { ok: false };
}

/**
 * Geocodificación inversa: coordenadas → calle, CP, población y provincia.
 * @param {number} lat
 * @param {number} lng
 */
export async function reverseGeocodePropiedad(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) {
    return { ok: false, error: "coords_invalid" };
  }
  try {
    const { data } = await api.post("/geo/reverse-geocode", { latitud: la, longitud: ln });
    return data || { ok: true, tiene_direccion: false, latitud: la, longitud: ln };
  } catch {
    return { ok: true, tiene_direccion: false, latitud: la, longitud: ln };
  }
}
